import React from "react";
import { Lock } from "lucide-react";

/**
 * Consentimento LGPD em duas caixas, ambas desmarcadas por padrão:
 *  - contato: obrigatório para enviar o formulário (o form valida)
 *  - marketing: opcional, enviado ao backend como marketing_consent
 */
export default function ConsentCheckboxes({
  idPrefix,
  contactText = "Autorizo o contato por WhatsApp e e-mail sobre esta solicitação.",
  contact,
  onContactChange,
  marketing,
  onMarketingChange,
  compact = false,
}) {
  const box = "mt-0.5 h-4 w-4 rounded border-input accent-primary cursor-pointer shrink-0";
  const text = "text-xs text-muted-foreground leading-relaxed";
  return (
    <div className={compact ? "space-y-2" : "bg-background/90 border border-border/80 rounded-xl p-4 space-y-2.5"}>
      {/* Honeypot anti-spam: invisível para pessoas, bots costumam preencher. Lido via honeypotValue(e). */}
      <input
        type="text"
        name="website"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        style={{ position: "absolute", left: "-9999px", width: 1, height: 1, opacity: 0 }}
      />
      <label htmlFor={`${idPrefix}-consent-contact`} className="flex items-start gap-2.5 cursor-pointer">
        <input
          type="checkbox"
          id={`${idPrefix}-consent-contact`}
          checked={contact}
          onChange={(e) => onContactChange(e.target.checked)}
          className={box}
        />
        <span className={text}>
          {contactText} <span className="text-primary" aria-hidden="true">*</span>
        </span>
      </label>
      <label htmlFor={`${idPrefix}-consent-marketing`} className="flex items-start gap-2.5 cursor-pointer">
        <input
          type="checkbox"
          id={`${idPrefix}-consent-marketing`}
          checked={marketing}
          onChange={(e) => onMarketingChange(e.target.checked)}
          className={box}
        />
        <span className={text}>Quero receber conteúdos e novidades patrimoniais por WhatsApp e e-mail (opcional).</span>
      </label>
      {!compact && (
        <div className="flex items-start gap-1.5 text-xs text-muted-foreground/90 pl-6">
          <Lock size={12} className="text-primary/70 shrink-0 mt-0.5" aria-hidden="true" />
          <span>
            Dados tratados conforme a LGPD (Lei nº 13.709/2018). Você pode pedir o cancelamento a qualquer momento.
          </span>
        </div>
      )}
    </div>
  );
}

/** Valor do campo honeypot do formulário que disparou o submit. */
export function honeypotValue(e) {
  return e?.target?.elements?.website?.value || "";
}
